import { ChevronDown } from "lucide-react";
import { PERIODS } from "./constants";

export default function PeriodDrop({ value, onChange, color }) {
  return (
    <div className="relative inline-flex items-center shrink-0 max-w-full">
      <select value={value} onChange={e => onChange(e.target.value)}
        className="text-[9.5px] pl-2 pr-5 py-[3px] rounded-full font-bold outline-none cursor-pointer appearance-none font-[inherit] whitespace-nowrap max-w-full leading-[1.2]"
        style={{ border:`1.5px solid ${color}25`, background:`${color}0E`, color }}>
        {PERIODS.map(o => <option key={o}>{o}</option>)}
      </select>
      <div className="absolute right-[5px] top-1/2 -translate-y-1/2 pointer-events-none flex items-center">
        <ChevronDown size={9} color={color} strokeWidth={3}/>
      </div>
    </div>
  );
}

